import { TObjectId } from "../types/api/shared";
import { TFluffyObjectItem } from "../types/models/TMcFluffy";

// This function added in solving https://timeedit.atlassian.net/browse/SCHED-1780
// We do not know whether the object type is a request type,
// so we consider the object being virtual as close enough.
// If this turns out to cause unwanted objects to remain selected
// we may need to look into other solutions
export const isRequestObject = (fluffyItem: TFluffyObjectItem | null) => {
    if (!fluffyItem) {
        return false;
    }
    return fluffyItem.virtual && fluffyItem.object.id > 0;
};

export const findNextSelectedItem = (
    items: TFluffyObjectItem[],
    currentSelectedItem: TFluffyObjectItem | null,
    selectedObject: TObjectId | null,
    selectNextItem: boolean,
    numReservations: number
) => {
    let selected: TFluffyObjectItem | null = null;
    let foundIndex = 0;
    const maxIndex = items.length - 1;
    items.some((item, index, array) => {
        // If we should not skip to the next type, find the last row of the current type and select it
        if (!selectNextItem && selected && item.type.id !== currentSelectedItem?.type.id) {
            return true;
        }

        // Select the next empty item
        if (selectNextItem && (item.object.id === 0 || (item.virtual && numReservations > 0))) {
            if (!selectedObject || selectedObject.id !== item.object.id) {
                selected = item;
                return true;
            }
        }

        // Mark current row as the potentially next one, but keep looking for more of the same type
        if (currentSelectedItem && item.type.id === currentSelectedItem.type.id) {
            foundIndex = index;
            selected = item;
            return false;
        }

        // Our last resort is selecting the last row
        if (index === maxIndex) {
            selected = array[maxIndex > foundIndex ? foundIndex + 1 : foundIndex]; // Return the line after the last selected one
            return true; // We are at the last item, return what we have.
        }
        return false;
    });
    return selected;
};
